export const MaintenanceEditDialogTitle = {
  add: 'メンテナンス新規登録',
  update: 'メンテナンス詳細編集',
};
